export default __webpack_public_path__ + "c9ec48a78f995bb132709427be0c0358.svg";